var _rect, _rect2, _path, _path2, _circle, _circle2, _path3, _ellipse, _path4, _path5, _path6, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtWork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 155,
    width: 260,
    height: 70,
    rx: 6,
    stroke: "#fafcfb",
    strokeOpacity: 0.35,
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 130,
    width: 70,
    height: 35,
    rx: 4,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 140h50M100 150h35",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168 145 Q168 75 210 60 Q252 75 252 145 Z",
    stroke: "#fafcfb",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 105,
    r: 3.5,
    fill: "#fafcfb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 105,
    r: 3.5,
    fill: "#fafcfb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198 120 Q210 128 222 120",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310,
    cy: 95,
    rx: 45,
    ry: 30,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M275 110 L255 130",
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M290 88 L310 88 M285 98 L325 98 M290 108 L315 108",
    stroke: "#fafcfb",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.55
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M265 75 Q275 65 285 75 M275 70 Q285 60 295 70",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 175,
    r: 8,
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtWork);
export default __webpack_public_path__ + "static/media/at-work.bc10e971586530b666078364b235d714.svg";
export { ForwardRef as ReactComponent };